import { render, staticRenderFns } from "./CheckMoreDepartment.vue?vue&type=template&id=5551f811"
import script from "./CheckMoreDepartment.vue?vue&type=script&lang=js"
export * from "./CheckMoreDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports